import { render, staticRenderFns } from "./Storage.vue?vue&type=template&id=266ccf78"
import script from "./Storage.vue?vue&type=script&lang=js"
export * from "./Storage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('266ccf78')) {
      api.createRecord('266ccf78', component.options)
    } else {
      api.reload('266ccf78', component.options)
    }
    module.hot.accept("./Storage.vue?vue&type=template&id=266ccf78", function () {
      api.rerender('266ccf78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/manager/pharmacy/Storage/Storage.vue"
export default component.exports